import React, { useState } from 'react';
import { BiConversation } from 'react-icons/bi';

import { useFormikContext } from 'formik';

import SettingsOption from '../SettingsOption';
import GuestQuestionModal from './GuestQuestionModal';

const GuestQuestionSetting = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const [showGuestQuestionModal, setShowGuestQuestionModal] = useState(false);

  const toggleGuestQuestionModal = () => {
    setShowGuestQuestionModal(
      (showGuestQuestionModal) => !showGuestQuestionModal
    );
  };

  const onSave = ({
    guestQuestions,
    googleForms
  }: {
    guestQuestions?: { question: string }[];
    googleForms?: { url: string };
  }) => {
    const filteredQuestions = guestQuestions.map(({ question }) => ({
      question
    }));
    setFieldValue('guestQuestions', filteredQuestions);
    setFieldValue('googleForms', googleForms);
  };

  return (
    <>
      <SettingsOption
        icon={<BiConversation size={20} />}
        title="Guest question"
        actionLabel="Add question"
        value={values?.guestQuestions?.length || values?.googleForms?.url || ''}
        onClick={toggleGuestQuestionModal}
        tooltipMessage="Specify any information you need from your guests, and we’ll make sure to get it from them when they join your event"
      />

      {showGuestQuestionModal && (
        <GuestQuestionModal
          onClose={toggleGuestQuestionModal}
          onSave={onSave}
          initialValues={{
            guestQuestions: values?.guestQuestions,
            googleForms: values?.googleForms
          }}
        />
      )}
    </>
  );
};

export default GuestQuestionSetting;
